import Hero from "../components/Hero";
import About from "../components/About";
import Services from "../components/Services";
import Projects from "../components/Projects";
import Testimonials from "../components/Testimonials";
import ContactForm from "../components/ContactForm";
import InstagramGrid from "../components/InstagramGrid";
import FloatingWhatsApp from "../components/FloatingWhatsapp";
import GoogleBusiness from "../components/GoogleBusiness";
import HomepageLatestEvent from "../components/HomepageLatestEvent";
import HowToBook from "../components/HowToBook";

import instagramData from "../data/instagram.json";

export default function Home() {
  return (
    <>
      <Hero />
      {/* <About /> */}
      <HomepageLatestEvent />
      <HowToBook />
    </>
  );
}
